import { useCallback, useEffect, useRef, useState } from "react";
import type { ShiftFormDocumentSettings } from "../../../shared/shift-production-form/contracts";
import { getDocumentSettings } from "./shift-production-form-gateway";

export function useDocumentSettings(enabled: boolean) {
  const [settings, setSettings] = useState<ShiftFormDocumentSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const requestVersion = useRef(0);
  const reload = useCallback(async () => {
    const version = ++requestVersion.current;
    setLoading(true);
    setError(null);
    try {
      const response = await getDocumentSettings();
      if (version === requestVersion.current) setSettings(response.settings);
    } catch (reason) {
      if (version === requestVersion.current)
        setError(
          reason instanceof Error
            ? reason.message
            : "Doküman bilgileri alınamadı.",
        );
    } finally {
      if (version === requestVersion.current) setLoading(false);
    }
  }, []);
  useEffect(() => {
    if (!enabled) {
      requestVersion.current += 1;
      setSettings(null);
      setError(null);
      setLoading(false);
      return;
    }
    void reload();
    return () => { requestVersion.current += 1; };
  }, [enabled, reload]);
  return { settings, loading, error, reload };
}
